<template>
  <div class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="email"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required, email: true }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-protocolo-email",
  template: `

    `,
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Email.vue